<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row class="mb-4" align="center">
        <v-col cols="auto">
          <h2 v-if="premiseData">
            {{ $t("basics.edit", { type: $t("basics.premise") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("basics.premise") }) }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="premiseEditForm">
        <v-row>
          <v-col cols="12">
            <v-text-field
              variant="outlined"
              flat
              :rules="[requiredRule, max256]"
              v-model="name"
              :label="$t('basics.name') + '*'"
              :readonly="readonly"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="premiseData && !premiseData.address">
          <v-col>
            <v-textarea
              variant="outlined"
              :label="$t('basics.oldAddress')"
              readonly
              v-model="premiseData.address_old"
              :rules="[max5000]"
              :readonly="readonly"
            >
            </v-textarea>
          </v-col>
        </v-row>

        <AddressComponentVue :addressData="address" :readonly="readonly" />

        <v-row v-if="!readonly">
          <v-col cols="12">
            <v-btn
              large
              block
              flat
              class="primaryButton"
              @click="confirm()"
              ref="confirmButton"
              style="width: 100%"
            >
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
import AddressComponentVue from "../main/AddressComponent.vue";

export default {
  name: "premiseEditDrawer",
  props: ["premiseData", "refreshDisplay", "readonly"],
  emits: ["close"],

  data() {
    return {
      name: undefined,
      address: {
        city: {
          zip_code: undefined,
          name: undefined,
          country: undefined,
        },
        street: undefined,
        housing_number: undefined,
        additional: undefined,
      },

      requiredRule: (value) => !!value || this.$i18n.t("messages.required"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),
      max5000: (value) =>
        !value ||
        value.length <= 5000 ||
        this.$i18n.t("messages.tooLong", { count: 5000 }),
    };
  },

  components: {
    AddressComponentVue,
  },

  watch: {
    refreshDisplay() {
      this.setValues();
    },
  },

  methods: {
    async confirm() {
      const { valid } = await this.$refs.premiseEditForm.validate();

      if (valid) {
        let formData = {};
        formData.name = this.name;
        formData.address = this.address;

        if (this.premiseData) {
          formData.id = this.premiseData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "localization/premises/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },

    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "localization/premises/patch/" + formData.id,
          formData
        )
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    setValues() {
      if (this.premiseData) {
        this.name = this.premiseData.name;

        if (this.premiseData.address) {
          this.address = JSON.parse(JSON.stringify(this.premiseData.address));
        } else {
          this.address = {
            city: {
              zip_code: undefined,
              name: undefined,
              country: undefined,
            },
            street: undefined,
            housing_number: undefined,
            additional: undefined,
          };
        }
      } else {
        this.name = undefined;

        this.address = {
          city: {
            zip_code: undefined,
            name: undefined,
            country: undefined,
          },
          street: undefined,
          housing_number: undefined,
          additional: undefined,
        };
      }
    },
  },

  mounted() {},
};
</script>
